import {
  adaptedToRapprochementBancaire,
  rapprochementBancaireToAdapted,
  rapprochementsBancairesToAdapted,
} from "../../adapter/rapprochementBancaireAdapter";
import { HttpMethod, initFetch } from "../../utils/fetcher";

export const LOAD_SUCCESS_RAPPROCHEMENTS_BANCAIRES = "LOAD_SUCCESS_RAPPROCHEMENTS_BANCAIRES";
export const LOAD_FAIL_RAPPROCHEMENTS_BANCAIRES = "LOAD_FAIL_RAPPROCHEMENTS_BANCAIRES";
export const SAVE_SUCCESS_RAPPROCHEMENTS_BANCAIRES = "SAVE_SUCCESS_RAPPROCHEMENTS_BANCAIRES";
export const SAVE_FAIL_RAPPROCHEMENTS_BANCAIRES = "SAVE_FAIL_RAPPROCHEMENTS_BANCAIRES";
export const UPDATE_SUCCESS_RAPPROCHEMENTS_BANCAIRES = "UPDATE_SUCCESS_RAPPROCHEMENTS_BANCAIRES";
export const UPDATE_FAIL_RAPPROCHEMENTS_BANCAIRES = "UPDATE_FAIL_RAPPROCHEMENTS_BANCAIRES";
export const DELETE_SUCCESS_RAPPROCHEMENTS_BANCAIRES = "DELETE_SUCCESS_RAPPROCHEMENTS_BANCAIRES";
export const DELETE_FAIL_RAPPROCHEMENTS_BANCAIRES = "DELETE_FAIL_RAPPROCHEMENTS_BANCAIRES";

export function loadRapprochementsBancaires() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch("rapprochementsBancaires", HttpMethod.GET);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.rapprochement_bancaire);
          dispatch({
            type: LOAD_SUCCESS_RAPPROCHEMENTS_BANCAIRES,
            payload: rapprochementsBancairesToAdapted(res.rapprochement_bancaire),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: LOAD_FAIL_RAPPROCHEMENTS_BANCAIRES,
            error: err,
          });
        });
    });
  };
}

export function saveRapprochementBancaire(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch("rapprochementsBancaires", HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToRapprochementBancaire(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(rapprochementBancaireToAdapted(res.rapprochement_bancaire));
          dispatch({
            type: SAVE_SUCCESS_RAPPROCHEMENTS_BANCAIRES,
            payload: rapprochementBancaireToAdapted(res.rapprochement_bancaire),
          });
        })
        .catch((err) =>
          dispatch({
            type: SAVE_FAIL_RAPPROCHEMENTS_BANCAIRES,
            error: err,
          })
        );
    });
  };
}

export function updateRapprochementBancaire(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`rapprochementsBancaires/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToRapprochementBancaire(jsonData)) })
        // make async call to database
        .then((res) => res.json())
        .then((res) => {
          resolve(rapprochementBancaireToAdapted(res.rapprochement_bancaire));
          dispatch({
            type: UPDATE_SUCCESS_RAPPROCHEMENTS_BANCAIRES,
            payload: rapprochementBancaireToAdapted(res.rapprochement_bancaire),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_RAPPROCHEMENTS_BANCAIRES,
            error: err,
          })
        );
    });
  };
}

export function deleteRapprochementBancaire(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`rapprochementsBancaires/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        // make async call to database
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.rapprochement_bancaire);
          dispatch({
            type: DELETE_SUCCESS_RAPPROCHEMENTS_BANCAIRES,
            payload: rapprochementBancaireToAdapted(res.rapprochement_bancaire),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_RAPPROCHEMENTS_BANCAIRES,
            error: err,
          });
        });
    });
  };
}
